import { FALLBACK_LANGUAGE } from './languages.constants.js';
/**
 * The language of `supported` a requested one stands for, else the fallback. Takes what browsers
 * and headers send: `sv-SE`, `SV`, or a list such as `sv-SE,sv;q=0.9` (its first entry wins).
 */
export function resolveLanguage(params) {
    const { requested, supported } = params;
    const normalized = requested?.toLowerCase().split(',')[0]?.trim().split('-')[0];
    return supported.find((language) => language === normalized) ?? FALLBACK_LANGUAGE;
}
